<template>
  <div
    id="header"
    class="header"
    :class="[{'show': showDash || ($route.path !== '/' && $route.path !== '/devicelist' && $route.path !== '/admin'), 'menu-open': dashStatus, 'menu-full': !computedWheelAccess}, computedMenuColorClass]"
  >
    <div v-if="showDash">
      <div
        class="header-wrapper"
        @click="toggleDashboard"
      >
        <ul class="section section--left">
          <li
            v-if="store.getData('user.access.virtualControl')"
            class="header__device-icon"
            :title="$tc('messages.header.virtualControlAccess', store.getData('user.access.virtualControl') ? 1 : 0)"
            @click.stop="virtualControlClick"
          >
            <img :src="computedDeviceIconSrc">
          </li>
          <li
            class="header__icon header__icon--help-text"
            :title="$t('messages.header.messagesAndAlerts')"
            :class="'header__icon--'+computedGetAlarms.maximumUrgency"
          >
            <font-awesome-icon :icon="['fas', 'bell']" />
            <span
              class="header__icon-count"
              :class="{'header__icon-count--spinner': computedGetAlarms.count === null }"
            >
              <span>{{ computedGetAlarms.count }}</span>
            </span>
          </li>
          <li
            :class="{'header__icon--limited-sync': !store.getData('user.access.sync')}"
            class="header__icon header__icon--connection header__icon--button"
            :title="store.getData('user.access.sync') ? ComputedSyncMessage : ComputedSyncMessage + '\n\nNo access to sync'"
            @click.stop="OpenSyncModal()"
          >
            <font-awesome-icon
              v-if="ConnectionInformation.icon"
              :title="$t(`messages.header.${ConnectionInformation.code}`)"
              :icon="['custom', ConnectionInformation.icon]"
            />
          </li>
          <li
            class="header__icon"
            :title="$tc('messages.header.connectionTimeout', 10, {n: computedTimeoutTitle})"
          >
            <svg
              class="g-clock"
              viewBox="0 0 32 32"
            >
              <circle
                r="16"
                cx="16"
                cy="16"
                class="g-clock__pie"
                :style="{strokeDasharray: 100 - computedTimeoutClock + ' 100'}"
                :class="{'g-clock__pie--yellow': (computedTimeoutClock < 50), 'g-clock__pie--red': (computedTimeoutClock < 25)}"
              />
            </svg>
          </li>
        </ul>
        <!-- Right side, reverse order -->
        <ul class="section section--right">
          <li
            v-if="computedCanToggleDash"
            class="header__icon"
          >
            <div class="header__menu">
              <div class="header__menu__button" />
            </div>
          </li>
          <li
            v-if="computedCanToggleDash"
            class="line"
          />
          <li>
            <div
              v-if="store.getData('controller.time') !== 0"
              class="time"
              :title="$t('messages.header.dateTime')"
            >
              {{ store.getData('controller.clientModifiedDevTime') }}
            </div>
          </li>
        </ul>
        <strong
          :title="$t('messages.header.headerHelp')"
          class="header-wrapper__title"
        >
          {{ computedHeaderTitle }}
        </strong>
      </div>

      <div class="section section--mobile">
        <span>{{ computedHeaderTitle }}</span>
        <span>{{ store.getData('controller.clientModifiedDevTime') }}</span>
      </div>

      <div
        class="panel-overlay"
        @click="toggleDashboard"
      />

      <div class="panel">
        <h3 class="panel__title">
          {{ $t('messages.header.hello') }} {{ store.getData('user').first_name }} {{ store.getData('user').last_name }} ({{ store.getData('user').login }})
        </h3>
        
        <div class="panel__buttons">
          <button
            class="g-btn g-btn--rounded panel__buttons__sort-widgets"
            @click.stop="sortWidgets = !sortWidgets"
          >
            {{ sortWidgets ? $t('messages.sharedTexts.stopSorting') : $t('messages.sharedTexts.sort') }}
          </button>
        </div>

        <div
          ref="widget-wrapper"
          class="panel__content widget-wrapper"
          :class="{'widget-wrapper--sort': sortWidgets}"
        >
          <div
            class="g-grey-box panel__content__element"
            data-name="controls"
          >
            <div class="g-handle" />
            <controls
              :rain-shut-down = "rainShutDown"
              :rain-shut-down-started = "rainShutDownStarted"
              :controller-group="store.getData('controller.group')"
              :controller-mode="store.getData('controller.mode')"
              :show-rain-shut-down-spinner = "store.getData('rainShutDown.showRainShutDownSpinner')"
              :store="store"
              :page-message="PageMessage"
              @SetPageMessage = "SetPageMessage"
            />
          </div>
          <!-- ALERTS -->
          <accordion-alerts
            data-name="alerts"
            :handle="true"
            :alarms="computedGetAlarms"
            @SetPageMessage="SetPageMessage"
          />
          <!-- WATER CONSUMPTION -->
          <!--
          <accordion-water-consumption
            data-name="waterConsumption"
            :handle="true"
            :water-consumption="store.getData('waterConsumption')"
            :store="store"
          />
          -->
          <!-- FLOW -->
          <accordion-flow
            data-name="flow"
            :handle="true"
            :store="store"
          />
          <!-- RUNNING Stations -->
          <accordion-stations
            class="panel__content__element"
            data-name="stations"
            :handle="true"
            :stations="store.getData('stations')"
            @toggleDashboard="toggleDashboard"
          />
          <!-- RUNNING PROGRAMS -->
          <accordion-programs
            data-name="programs"
            :handle="true"
            :programs="store.getData('programs')"
            @toggleDashboard="toggleDashboard"
          />
          <!-- ELECTRICAL -->
          <accordion-electrical
            data-name="electrical"
            :handle="true"
            :voltage="store.getData('voltage')"
            :current="store.getData('current')"
          />
          <!-- MOISTURE -->
          <accordion-moisture
            v-if="store.getData('controller.group') !== 'TWC' && store.getData('controller.group') !== 'AIC'"
            data-name="moisture"
            :handle="true"
            :store="store"
            :moisture="store.getData('moisture')"
          />
          <!-- CONTROLLER MODE -->
          <accordion-controller-mode
            data-name="controllerMode"
            :handle="true"
            :socket-message = "SocketMessage"
            :controller-mode="store.getData('controller.mode')"
            :controller-modes="computedControllerModes"
            :return-controller-mode="computedControllerMode"
            @SetPageMessage="SetPageMessage"
          />
        </div>
      </div>
    </div>
    <div
      v-else-if="$route.path !== '/' && $route.path !== '/devicelist'" 
      class="header-wrapper header-wrapper--not-logged-in"
    >
      <!-- <strong>{{ $i18n.whitelabel.appTitle }}</strong> -->
    </div>
  </div>
</template>

<script>
/* Mixins */
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'
/* ------ */
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'

import * as iconsLib from '@/assets/javascript/Icons-lib'; // eslint-disable-line
import {secondsToObj} from '@/assets/javascript/Time-lib'
import moment from 'moment'
import dragula from 'dragula'

// import Accordion from '@/components/elements/AccordionElement'
import AccordionAlerts from '@/components/combinations/AccordionAlerts'
// import AccordionWaterConsumption from '@/components/combinations/AccordionWaterConsumption'
import AccordionFlow from '@/components/combinations/AccordionFlow'
import AccordionStations from '@/components/combinations/AccordionStations'
import AccordionPrograms from '@/components/combinations/AccordionPrograms'
import AccordionElectrical from '@/components/combinations/AccordionElectrical'
import AccordionMoisture from '@/components/combinations/AccordionMoisture'
import AccordionControllerMode from '@/components/combinations/AccordionControllerMode'
import Controls from '@/components/combinations/Controls'

export default {
  name: 'Header',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    'accordion-alerts': AccordionAlerts,
    // 'accordion-water-consumption': AccordionWaterConsumption,
    'accordion-flow': AccordionFlow,
    'accordion-stations': AccordionStations,
    'accordion-programs': AccordionPrograms,
    'accordion-electrical': AccordionElectrical,
    'accordion-moisture': AccordionMoisture,
    'accordion-controller-mode': AccordionControllerMode,
    'controls': Controls
  },
  mixins: [SocketHandler, LifeCycle],
  props: {
    SelectedDevice: {
      type: Object,
      default: function() {
        return{}
      }
    },
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    },
    LoggedIn: {
      type: Boolean,
      default: false
    },
    DoNotShowWheel: {
      type: Boolean,
      default: false
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ConnectionInformation: {
      type: Object,
      default: function() {
        return{}
      }
    },
    programs: {
      type: Array,
      default: function() {
        return[]
      }
    },
    rainShutDown: {
      type: Number,
      default: null
    },
    rainShutDownStarted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return{
      dragula: null, // this data field is only used for monitoring
      sortWidgets: false,
      dashStatus: false,
      surveyActive: false,
      library
    }
  },
  computed: {
    computedControllerModes() {
      const standardModes = [
        {number: 0, value: 'irroff'},
        {number: 1, value: 'manual'},
        {number: 2, value: 'auto'},
      ]

      const advancedModes = [
        {number: 3, value: 'program'},
        {number: 4, value: 'setup'},
        {number: 5, value: 'advanced'}
      ]
      return this.store.getData('user.access').virtualControl ? [...standardModes, ...advancedModes] : standardModes
    },
    computedSettings() {
      return this.store.getData('settings')
    },
    computedTimeoutTitle() {
      const time = this.store.getData('controller.clientModifiedTime')
      const timeoutEnd = this.store.getData('controller.clientTimeoutTime')

      let runtime = secondsToObj((timeoutEnd - time) / 1000)
      
      const hours = (runtime.hh !== 0) ? runtime.hh + this.$tc('messages.sharedTexts.time.h', 1) : ''
      const minutes = (runtime.mm !== 0) ? runtime.mm + this.$tc('messages.sharedTexts.time.m', 1) : ''
      const seconds = (runtime.ss !== 0) ? runtime.ss + this.$tc('messages.sharedTexts.time.s', 1) : ''

      return `${hours} ${minutes} ${seconds}`
    },
    computedTimeoutClock() {
      const time = this.store.getData('controller.clientModifiedTime')
      const timeoutStart = this.store.getData('controller.clientTimeoutTime')
      const timeoutEnd = this.store.getData('controller.clientTimeoutTime')
      
      const progress = (100 / 720000) * (timeoutEnd - time)

      if (time && timeoutStart && timeoutEnd) return progress //controllerTime * 100

      return 0
    },
    computedGetAlarms() {
      return this.store.getData('alarms')
    },
    computedDeviceIconSrc() {
      return iconsLib.getDeviceGraphic(this, 'icon', this.store.getData('controller.deviceData.typename'))
    },
    computedMenuColorClass() {
      const alarms = this.computedGetAlarms
      const rainShutDown = this.store.getData('rainShutDown.time')
      const mode = this.store.getData('controller.mode')

      if(mode && !this.DoNotShowWheel) { // it must have a mode
        if(alarms.maximumActiveUrgency === 0 && rainShutDown !== 0) {
          return 'menu-color--rainshutdown'
        } else if(alarms.maximumActiveUrgency > 0) {
          return `menu-color--${alarms.maximumActiveUrgency}`
        } else if(mode === 2 && rainShutDown === 0) {
          return 'menu-color--auto'
        } else {
          return 'menu-color--0'
        }
      }

      return ''
    },
    computedCanToggleDash() {
      return this.computedWheelAccess || (this.$route.path !== '/home' && this.$route.path !== undefined)
    },
    computedWheelAccess() {
      return this.store.getData('user.access.wheel')
    },
    computedHeaderTitle() {
      let rtnStr = ''

      if(this.SelectedDevice.devDescription) {
        rtnStr += this.SelectedDevice.devDescription
      } else if(this.SelectedDevice.typename) {
        rtnStr += this.SelectedDevice.typename
      }

      if(this.SelectedDevice.devDescription && this.computedControllerMode) {
        rtnStr += ` · ${this.computedControllerMode}`
      }
      return rtnStr
    },
    ComputedSyncMessage() {
      const msg = this.$t(`messages.header.${this.ConnectionInformation.code}`)
      return (this.ConnectionInformation.message !== 'Synced') ? msg + this.$t('messages.header.syncAccess') : msg
    },
    computedControllerMode() {
      let controllerModeName = ''

      if(this.RainShutDown) {
        controllerModeName = this.$t('messages.sharedTexts.rainShutdown')
      } else {
        controllerModeName = this.computedControllerModes.find((item) => item.number === this.store.getData('controller.mode'))

        controllerModeName = controllerModeName !== undefined
        ? this.$t(`messages.header.${controllerModeName.value}`)
        : ''
      }

      controllerModeName = controllerModeName !== ''
      ? controllerModeName
      : ''

      return controllerModeName
    },
    showDash() {
      return !this.DoNotShowWheel &&
             this.LoggedIn && this.store.getData('user.access.ngwi') &&
             this.store.getData('controller.clientModifiedDevTime') !== null
    }
  },
  watch: {
    PageMessage() {
      if(this.PageMessage.target === 'Dashboard') {
        if(this.PageMessage.message === 'close') this.dashStatus = false
      }
    },
    showDash(state) {
      this.$nextTick(() => {
        if(state) {
          // When dash is ready handle children.
          const getChildren = el => [...el.childNodes]
          const containerWrapper = this.$refs['widget-wrapper']

          // initial sort
          if(this.computedSettings.dashSort) {
            const dashSort = this.computedSettings.dashSort.slice().reverse() // clone since reverse is mutating

            dashSort
              .forEach(childName => {
                const containerChildren = getChildren(containerWrapper)
                const match = containerChildren.find(child =>
                  child.getAttribute && child.getAttribute('data-name') === childName)

                match
                ? containerChildren[0].before(match)
                : console.warn(childName, 'not found')
              }
            )
          }

          let drake = dragula([containerWrapper], {
            moves: function (el, container, handle) {
              return handle.classList.contains('g-handle')
            }
          })

          this.dragula = drake

          drake.on('dragend', (el) => {
            const order = getChildren(drake.containers[0])
              .map(el => el.getAttribute && el.getAttribute('data-name'))
              .filter(name => typeof name === 'string')

            this.store.setData('settings.dashSort', order)
            localStorage.setItem('NGWI_SETTINGS', JSON.stringify(this.computedSettings))
          })
        }
      })
    },
    '$route'(to) {
      this.title = this.$route.meta.title

      to.path === '/home'
      ? this.dashStatus = !this.computedWheelAccess
      : this.dashStatus = false
    },
    dashStatus(status) {
      this.SocketMessageSend({
        component: 'Header',
        command: 'SetState',
        position: status ? 'Up' : 'Down'
      })

      if(!status) this.sortWidgets = false
    }
  },
  mounted() {
    // console.log('header mounted')
  },
  methods: {
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    openHandleAlert(component) {
      this.$emit('ShowModal', {
        component: 'AlarmHandler',
        data: {
          handler: component
        }
      })
    },
    OpenSyncModal() {
      if(!this.store.getData('user.access.sync')) return // no access

      this.$emit('SetPageMessage', {
        target: 'ShowModal',
        modalData: {
          component: 'SyncModal',
          store: this.store
        }
      })
    },
    virtualControlClick() {
      if(!this.store.getData('user.access.virtualControl')) return // access denied

      if(this.$route.path !== 'survey') {
        this.$emit('SetPageMessage', {
          target: 'ShowModal',
          modalData: {
            component: 'JSControl',
            data: this.SelectedDevice
          }
        })
      }
    },
    Refresh() {
      this.SocketMessageSend({ component: 'Header', command: 'Refresh' })
    },
    toggleDashboard() {
      if(this.computedWheelAccess) this.dashStatus = !this.dashStatus
      else if(this.computedCanToggleDash) this.dashStatus = !this.dashStatus
    }
  }
}
</script>

<style lang="scss">
  .header {
    width: 100%;

    &.show {
      height: $HeaderHeight;
    }

    > div {
      height: inherit;
    }

    &.menu-color--rainshutdown {
      .header-wrapper, .section--mobile {
        background-color: $color-header;
      }
    }

    &.menu-color--auto {
      .header-wrapper, .section--mobile {
        background-color: $color-header-auto;
      }
    }

    &.menu-color--2 {
      .header-wrapper, .section--mobile {
        background-color: darken(tint($color-yellow-warn, $color-red, 70), 10);
      }
    }
    &.menu-color--3 {
      .header-wrapper, .section--mobile {
        background-color: darken($color-red-error, 20);
      }
    }

    &__menu {
      position: relative;
      width: 28px;
      height: 28px;
      cursor: pointer;

      &__button {
        @include burger();
      }
    }

    &-wrapper {
      height: inherit;
      z-index: $z-ui + 2;
      @include hardware-accelerate(false);
      background-color: $color-header;
      position: relative;
      display: flex;
      justify-content: space-between;
      transition: background-color 1s;

      &__title {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        color: $color-white;
        display: none;
      }

      > * {
        flex: 0 1 auto;
      }

      &--not-logged-in{
        display: flex;
        align-items: center;
        justify-content: center;
        background: $color-grey-dark;
        color: $color-white;

        > * {
          flex: 0 1 auto;
        }
      }

      .time {
        display: none;
      }
    }

    &__device-icon {
      cursor: pointer;
      height: 100%;
      background: $color-white;
      img {
        display: inline-block;
        height: 100%;
      }
    }

    &__icon {
      font-size: 30px;
      position: relative;
      color: lighten($color-black, 10);

      &--1 { // info
        color: $color-green-ok;
      }
      &--2 { // warning
        color: $color-yellow-warn;
      }
      &--3 { // error
        color: $color-red-error
      }

      &--limited-sync {
        overflow: hidden;
        width: 10%;

        > * {
          transform: translateX(-38%);
        }
      }

      &--help-text {
        cursor: help;
      }

      &--button {
        cursor: pointer;
      }

      &--connection {
        background: rgba($color-white, 0.75);
        padding: 4px 5px 0px;
        border-radius: $application-base-border-radius;
        align-items: center;

        > * {
          margin: 0;
          height: 25px;
          vertical-align: baseline;
        }
      }
    }

    &__icon-count
    {
      position: absolute;
      bottom: 0;
      right: -4px;
      font-size: 13px;
      stroke: black;
      stroke-width: 10;

      &--spinner {
        @include spinner('before', 5px, 1px, $color-black);

        &:before {
          position: absolute;
          top: 0;
          left: 0;
          $size: 7px;
          margin: 5px;
          display: flex;
          width: $size;
          height: $size;
          justify-content: center;
          align-items: center;
        }

        span {
          display: none;
        }
      }

      span {
        $size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: $size;
        height: $size;
        border-radius: 50%;
        background: rgba($color-white, 0.75);
        color: $color-black;
      }
    }
  }

  .time {
    margin-right: 5px;
    color: $color-white;
    font-size: 11px;
    padding-left: 10px;
    text-align: right;
  }

  .line {
    height: 30px;
    margin: 0;
    border-left: 2px solid white;
  }

  .section {
    display: inline-flex;
    align-items: center;
    height: 100%;

    > * {
      flex: 0 1 auto;
      margin-right: 6px;

      &:last-child {
        margin-right: 0;
      }
    }

    &--right {
      flex-direction: row-reverse;
    }

    &--left > * {
      margin-right: auto;
      margin-right: 15px;
    }

    &--mobile {
      box-sizing: border-box;
      width: 100%;
      height: auto;
      transform: translateZ(0);
      z-index: $z-ui + 3;
      font-size: 11px;
      padding: 4px;
      justify-content: space-between;
      color: $color-white;
    }
  }

  .disconnect-bar-outer {
    width: 74px;
    height: 13px;
    background-color: darken($color-white, 20);
    border: 1px solid $color-white;
    position: relative;
  }

  .disconnect-bar {
    width: 72px;
    height: 11px;
    background-color: #17578a;
    text-align: center;
    color: white;
    margin-top: 1px;
    margin-left: 1px;
  }

  .panel-overlay {
    @include hardware-accelerate(false);
    position: absolute;
    width: 100vw;
    height: calc(100% - #{$HeaderHeight});
    transform: translateX(-100%);
    transition: background-color 0.4s;
    transition-delay: 0.50s;
    z-index: $z-ui+1;

    .menu-open & {
      background: rgba($color-black, 0.5);
      transform: translateX(0%);
    }
  }

  .panel {
    @include hardware-accelerate(false);
    position: absolute;
    top: $HeaderHeight;
    bottom: 0;
    left: 100%;
    background-color: $color-blue-dusty;
    overflow: hidden;
    height: calc(100% - #{$HeaderHeight});
    // box-shadow: 2px 2px 3px rgba($color-grey-dark, 0.5);
    overflow-y: auto;
    width: 100%;

    /* Animation */
    z-index: $z-ui+2;
    transition: all $DashAnimationSpeed ease-in-out;
    transform: translateX(0);

    &__buttons {
      text-align: right;
      margin: 10px 5px 0 ;

      .g-btn {
        margin: 0 5px;
      }
    }

    .time {
      color: $font-primary-color;
      font-size: 14px;
    }

    .menu-open & {
      transform: translateX(-100%);
    }

    &__content {
      overflow: hidden;
    }

    &__title {
      margin: $application-base-padding * 1.5 $application-base-padding 0;
      padding: $application-base-padding * 2;
      box-shadow: 2px 2px 3px rgba($color-grey-dark, 0.5);
      background-color: $color-grey-light;
      border-radius: $application-base-border-radius;
      border-top-right-radius: 0;
      border-top-left-radius: 0;
      text-align: center;
    }

    .widget-wrapper {
      .g-handle {
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.4s ease-in-out;
      }
      &--sort .g-handle {
        opacity: 1;
        pointer-events: all;
        transition: opacity 0.4s ease-in-out;
      }
    }

    .panel__content__element {
      position: relative;
      @include clearfix();
      margin: 0;
      margin: 10px;
    }
  }

  @media screen and (min-width: $bp-mobile) {
    .header {
      .panel {
        &__programs {
          grid-template-columns: repeat(2, 1fr);
          &__program {
            text-align: left;
            cursor: pointer;
            > * {
              margin-top: 0;
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: $bp-tablet) {
    .header {
      &.menu-full {
        .panel, .panel__content__element {
          max-width: none;
        }
      }

      &-wrapper {
        &__title {
          display: block;
        }

        .time {
          font-size: 16px;
          display: block !important;
        }
      }
      .section {
        > * {
          margin-right: 12px;
        }

        &--mobile {
          display: none;
        }
      }
      .panel-overlay {
        height: calc(100% - #{$HeaderHeight} - #{$FooterHeight});
      }
      .panel {
        max-width: 575px;

        height: calc(100% - #{$HeaderHeight} - #{$FooterHeight});
        &__title {
          display: none;
        }
        &__content {
          &__element {
            max-width: 575px;
          }
        }
      }
    }
  }
</style>
